import { render } from "./YumsSection.vue?vue&type=template&id=5be90696&scoped=true"
import script from "./YumsSection.vue?vue&type=script&lang=js"
export * from "./YumsSection.vue?vue&type=script&lang=js"

import "./YumsSection.vue?vue&type=style&index=0&id=5be90696&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be90696"]])

export default __exports__